import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import VerticalNavLink from '../verticalNavLink';

function MAListAccountAdmin({ handleDrawerToggle, onActive }) {
    return (
        <List disablePadding>
            <VerticalNavLink
                onActive={onActive}
                to={'/media-shuttle/account-administration/security/securing-your-portal'}
                onClick={handleDrawerToggle}
                secondary={'Securing Your Portals'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/media-shuttle/account-administration/security/saml/understanding-saml'}
                onClick={handleDrawerToggle}
                secondary={'Understanding SAML'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/media-shuttle/account-administration/security/saml/configuring-saml'}
                onClick={handleDrawerToggle}
                secondary={'Configuring SAML'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/media-shuttle/account-administration/security/saml/troubleshooting-saml'}
                onClick={handleDrawerToggle}
                secondary={'Troubleshooting SAML'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/media-shuttle/account-administration/security/saml/saml-adfs'}
                onClick={handleDrawerToggle}
                secondary={'Authenticating with AD FS'}
            />
        </List>
    );
}

MAListAccountAdmin.propTypes = {
    onActive: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
};

export default MAListAccountAdmin;
